export default "__VITE_ASSET__CHw03qBi__"